module.exports = __webpack_public_path__ + "static/one-hundred-years-of-solitude-1ee63438f8aa314b34d543bd9c7d5053.jpg";